import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { MyWalletResourcePackage } from "../../../resources/MyWalletResourcePackage";
import { NFTScrollItem } from "./NFTScrollItem";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { IDestroyOptions, Text, TextStyle } from "pixi.js";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { NFTPackage, TraitType } from "by/gamefactory/web3/nfts/NFTPackage";

export class NFTDiceRollsScrollItem extends NFTScrollItem {
    private static readonly BUTTON_TEXT = 'COLLECT';
    private static readonly DICE_SIDE_SIZE = 282;

    private readonly collectButton: ButtonWithScaleAnimation;
    private readonly diceCountText: Text;

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        commonResources: CommonResourcesPackage,
        data: NFTPackage
    ) {
        super(myWalletResources.assets_views_my_wallet_ui_dice_png, data);
        this.image.width = this.image.height = NFTDiceRollsScrollItem.DICE_SIDE_SIZE;

        this.collectButton = new ButtonWithScaleAnimation(commonResources.assets_common_ui_button_green_png);
        this.collectButton.defaultView.height = 155;
        this.collectButton.defaultView.width = 300;
        const buttonText = new Text(NFTDiceRollsScrollItem.BUTTON_TEXT, new ButtonTextStyle());
        buttonText.position.set(83, 40);
        this.collectButton.addChild(buttonText);

        const diceCount = data.rewards?.find(reward => reward.type === TraitType.DICE_ROLLS)?.value ?? 0;
        this.diceCountText = new Text(diceCount, new DiceCountTextStyle());
        this.addChild(this.collectButton, this.diceCountText);
        this.layout();
        this.collectButton.onUp.add(this.onCollectButtonClickHandle, this);
    }

    private layout(): void {
        this.collectButton.position.set(-10, 479);
        this.diceCountText.position.set((this.image.width - this.diceCountText.width) * 0.5, 290);
    }

    private onCollectButtonClickHandle(): void {
        this.onCollect.emit(this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.collectButton.onUp.remove(this.onCollectButtonClickHandle, this);
        super.destroy(options);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 51.28,
            fill: 'FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.7,
            dropShadowBlur: 4,
            dropShadowColor: '0D0606',
            dropShadowDistance: 2
        });
    }
}

class DiceCountTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 182,
            fill: 'FFFFFF',
            trim: true
        });
    }
}
